<res-custom-checkbox [automationId]="'grid-slide-toggle-button'"
    [(ngModel)]="agParams.data.istoggleOn" [isSkeuomorphic]="true" [isToggleBox]="true"
    (ngModelChange)="sliderToggleStateChanged()" [hasCustomClass]="true"></res-custom-checkbox>